import { createSlice } from '@reduxjs/toolkit'
import { sliceStateStatus } from '../../../../Core';

import ISliceState from '@/interface/core/ISliceState';
import IAssociation from '@/interface/IAssociation';

import {
  associationDestroy,
  associationStore,
  associationUpdate,
} from './associationsActions';



const initialState: ISliceState<IAssociation> = {
  data: undefined,
  status: sliceStateStatus.idle,
};

const associationSlice = createSlice({
  name: 'association',
  initialState,
  reducers: {
    resetAssociationState: () => initialState,
    setActiveAssociation: (state, action) => {
      state.data = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(associationStore.pending, (state) => {
        state.status = sliceStateStatus.pending;
      })
      .addCase(associationStore.fulfilled, (state, action) => {
        state.status = sliceStateStatus.fulfilled;
        state.data = action.payload.data[0];
      })
      .addCase(associationStore.rejected, (state) => {
        state.status = sliceStateStatus.rejected;
      })

      .addCase(associationUpdate.pending, (state) => {
        state.status = sliceStateStatus.pending;
      })
      .addCase(associationUpdate.fulfilled, (state, action) => {
        state.status = sliceStateStatus.fulfilled;
        state.data = action.payload.data[0];
      })
      .addCase(associationUpdate.rejected, (state) => {
        state.status = sliceStateStatus.rejected;
      })

      .addCase(associationDestroy.pending, (state) => {
        state.status = sliceStateStatus.pending;
      })
      .addCase(associationDestroy.fulfilled, (state) => {
        state.status = sliceStateStatus.fulfilled;
        state.data = undefined; // È stata eliminata
      })
      .addCase(associationDestroy.rejected, (state) => {
        state.status = sliceStateStatus.rejected;
      });
  }
});

export const { resetAssociationState, setActiveAssociation } = associationSlice.actions;
export default associationSlice.reducer;